module.exports = __webpack_public_path__ + "static/img/3.a14b880.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/3.png
// module id = wVSm
// module chunks = 0